export var FTunnelPageStepEnum;
(function (FTunnelPageStepEnum) {
    FTunnelPageStepEnum["booking"] = "booking";
    FTunnelPageStepEnum["validation"] = "validation";
    FTunnelPageStepEnum["confirmation"] = "confirmation";
})(FTunnelPageStepEnum || (FTunnelPageStepEnum = {}));
export var FTunnelPageBookingTypeEnum;
(function (FTunnelPageBookingTypeEnum) {
    FTunnelPageBookingTypeEnum["voucher"] = "voucher";
    FTunnelPageBookingTypeEnum["standard"] = "standard";
})(FTunnelPageBookingTypeEnum || (FTunnelPageBookingTypeEnum = {}));
export var FPaymentModeEnum;
(function (FPaymentModeEnum) {
    FPaymentModeEnum["ONLINE"] = "online";
})(FPaymentModeEnum || (FPaymentModeEnum = {}));
